module.exports = __webpack_public_path__ + "static/media/gladsaxe_logo.06a63133.png";